import { Component } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
import { history } from '../../../store';

class Featured extends Component {
  render() {
    return (
      <div className="featured-article-list">
        {this.props.articles.map(article => (
          <div key={article.id}>
            <div
              className="article-title-link"
              onClick={() => {
                history.push(`/article/${article.id}`);
              }}
            >
              <Row className="featured-article-img">
                <img src={article.link.image}/>
              </Row>
              <Row className="featured-article-title">
                {article.title}
              </Row>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

Featured.propTypes = {
  articles: PropTypes.array.isRequired
};

export default Featured;
